<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>

    <card-component
      class="relative mt-2 px-2 md:px-4 bg-white border border-gray-100 dark:bg-gray-900 dark:border-gray-600"
      :title="$t('employee.update_history')"
      :icon="mdiClipboardAccountOutline"
      has-table
    >
      <ag-grid-vue
        ref="agGridteacher"
        style="width: 100%; height: 70vh"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :pagination="true"
        :context="context"
        :rowData="employeeHistory"
        rowSelection="single"
        @grid-ready="onGridReady"
        @first-data-rendered="handleFirstDataRendered"
      />
    </card-component>
</template>

<script>
/* eslint-disable */
import { ref, reactive, watch, onMounted, onBeforeUnmount } from "vue";
import { mdiClipboardAccountOutline, mdiClose } from "@mdi/js";
import { useToast } from "vue-toastification";
import { AgGridVue } from "ag-grid-vue3";
import { useI18n } from "vue-i18n";
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import MainSection from "@/components/MainSection";
import CardComponent from "@/components/CardComponent";

export default {
  name: "EmployeeAuditHistory",

  components: {
    MainSection,
    CardComponent,
    AgGridVue,
    Loading,
  },

  props: {
    employeeHistory: {
      type: Array,
      default: () => ([]),
    },
  },

  emits: ["close-modal", "submit"],

  data() {
    return {
      gridApi: null,
      gridColumnApi: null,
      context: { componentParent: this },
    };
  },

  setup(props) {
    const { t } = useI18n();
    const toast = useToast();

    const isLoading = ref(false);
    const rowData = ref([]);

    const defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      wrapText: true,
      autoHeight: true,
    };

    const columnDefs = [
      {
        headerName: "#",
        valueGetter: "node.rowIndex + 1",
        width: 60,
      },
      {
        field: "user_name",
        headerName: t("employee.updated_by"),
        minWidth: 150,
      },
      {
        field: "created_at",
        headerName: t("employee.updated_at"),
        minWidth: 180,
      },
      {
        field: "changes",
        headerName: "Changes",
        autoHeight: true,
        wrapText: true,
        minWidth: 400,
        cellRenderer: (params) => {
          if (!params.value || !params.value.length) return "-";

          return `
        <ul style="padding-left:16px;margin:0">
          ${params.value
            .map(
              (c) => `<li style="white-space:normal;line-height:1.4">${c}</li>`
            )
            .join("")}
        </ul>
      `;
        },
      },
    ];

    return {
      isLoading,
      rowData,
      columnDefs,
      defaultColDef,
      mdiClipboardAccountOutline,
      mdiClose,
      t,
    };
  },

  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.autoSize(params);
    },

    handleFirstDataRendered(params) {
      this.autoSize(params);
    },

    autoSize(params) {
      const allColumnIds = [];
      params.columnApi.getAllColumns().forEach((col) => {
        allColumnIds.push(col.getColId());
      });
      params.columnApi.autoSizeColumns(allColumnIds, false);
      params.api.sizeColumnsToFit();
    },

    handleClickOutside(e) {
      const ref = this.$refs.agGridteacher;
      if (!ref || !this.gridApi) return;

      const gridEl = ref.$el;
      if (gridEl && !gridEl.contains(e.target)) {
        this.gridApi.deselectAll();
      }
    },
  },

  mounted() {
    document.addEventListener("mousedown", this.handleClickOutside);
  },

  beforeUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  },
};
</script>
